import React, { useEffect } from 'react';
import '../style/testimonial.css';
import image1 from '../images/c1.jpeg'
import image2 from '../images/c2.jpeg'
import image3 from '../images/c3.jpeg'
import image4 from '../images/c4.jpeg'
import image5 from '../images/c5.jpeg'
import image6 from '../images/c6.jpeg'
import image7 from '../images/c7.jpeg'

const testimonials = [
    {
        avatar: image1,
        name: "Vineet Tyagi",
        review: "Thankful to Umang for his continuous support, which helped me understand my role as an owner and how can i implement these practically, offcourse this is all is time taking and patience have to be there but this journey is worthful. I recommend him and wish him all the best."
    },
    {
        avatar: image2,
        name: "Vipul M. Mali",
        review: "Dr CA Umang Ratani is going amazing work and having very good domain knowledge with great spirit. He is always positive and innovative at work."
    },
    {
        avatar: image3,
        name: "CA Shreya Davda",
        review: "He is my teacher, my coach & my boss too now😅 Conversation with him always inspires our team to deliver the best of us ! Also, don't know how but he asks the right questions which leave me with a deep thought through which I am now able to look at things in a different approach & started doing things that matter to me😊 Being an effective communicator & motivator possessing practical knowledge of business, technology & psychology, he is the great mentor"
    },
    {
        avatar: image4,
        name: "Krupali Trivadi",
        review: "A Great Mentor and A Friendly Human Being. I have seen him helping and supporting everyone and his teachings will stay with you forever. A person caring about the time and quality. Stranger or not, he will always give the best piece of advice. "
    },
    {
        avatar: image5,
        name: "Shivam Seth",
        review: "Umang Sir embodies exceptional dedication, simplicity, continuous learning, and remarkable communication skills. He is a true inspiration, committed and hardworking. Despite his vast knowledge and achievements, Umang Sir remains humble and approachable. He has a remarkable talent for simplifying complex concepts and is an excellent mentor. With his thirst for knowledge and calm demeanor, Umang Sir is a valuable asset in any professional setting. It is a privilege to work alongside him, and his qualities make him highly regarded for any future endeavors."
    },
    {
        avatar: image6,
        name: "CA Deep Anadkat",
        review: "FCA CS Umang Ratani is one of best coach, guide and teacher I have in my life. With his NLP workshop I got so much positive change in my life and in my work success. always obey you sir! Thank you for always there with me."
    },
    {
        avatar: image7,
        name: "CA Poonam Pathak",
        review: "Umang is an amazing personality. A multi-talented and ever smiling. I attended his session on NLP, Its very helpful for me."
    }
];

const Testimonial = () => {
    useEffect(() => {
        // eslint-disable-next-line no-undef
        const swiper = new Swiper('.swiper-container', {
            grabCursor: true,
            centeredSlides: true,
            slidesPerView: 2.3,
            loop: true,
            spaceBetween: 30,
            effect: 'coverflow',
            coverflowEffect: {
                rotate: 0,
                depth: 800,
                slideShadows: true,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            autoplay: {
                delay: 2500,
                disableOnInteraction: false
            },
        });

        const queryResizer = () => {
            if (window.innerWidth < 724) swiper.params.slidesPerView = 2;
            if (window.innerWidth > 501) swiper.params.slidesPerView = 2;
            if (window.innerWidth > 724) swiper.params.slidesPerView = 2.3;
            if (window.innerWidth < 501) swiper.params.slidesPerView = 1;
            swiper.update();
        };

        window.addEventListener('resize', queryResizer);
        queryResizer();

        return () => {
            window.removeEventListener('resize', queryResizer);
        };
    }, []);

    return (
        <>
            <section style={{ textAlign: 'center', marginTop: "50px", marginBottom: "50px", color:'rgb(13 92 126)' }}>
                <h3>TESTIMONIALS</h3>
            </section>
            <span id='cont' >
                <div id="craouselContainer" className="swiper-container">
                    <div className="swiper-wrapper" id="slideHolder">
                        {testimonials.map((testimonial, index) => (
                            <div key={index} className="swiper-slide">
                                <div className="ImgHolder">
                                    <img src={testimonial.avatar} alt={testimonial.name} />
                                </div>
                                <div className="ContentHolder">
                                    <h3>{testimonial.name}</h3>
                                    <p>{testimonial.review}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="swiper-pagination"></div>
                </div>
            </span>
        </>
    );
};

export default Testimonial;
